import { Component, OnInit, Input, HostListener } from '@angular/core';
import { MainService } from '../../services/main.service';
import { Router } from '@angular/router';

declare const $;
declare const window;
declare const Email;

@Component({
  selector: 'app-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: ['./contact-page.component.scss']
})
export class ContactPageComponent implements OnInit {

  @Input() whiteNavbar;
  source: string;
  mshop_color;
  name = '';
  email = '';
  message = '';
  emailSendedMessage;


  constructor(private mainService: MainService,
  private router: Router) {
    this.mshop_color = false;
    if (this.mainService.getSource() === 'm-shop') {
      this.mshop_color = true;
    }
    this.whiteNavbar = true;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.homeScreenLaying();
  }

  ngOnInit() {
    if (window.innerWidth > 991) {
      this.homeScreenLaying();
    }
    window.scrollTo(0, 0);
  }

  private homeScreenLaying() {
    $('.contact-blank').height(window.innerHeight * 0.1);
    $('.contact-content').css('min-height', window.innerHeight * 0.9);
  }

  public sendEmail() {
    let destinyEmail = 'm-shop.mobi';
    let brand = 'MSHOP';
    if (this.mainService.getSource() === 'm-shop') {
      destinyEmail = 'm-shop.mobi';
      brand = 'MSHOP';
    } else if (this.mainService.getSource() === 'codinfos') {
      destinyEmail = 'codinfos.com';
      brand = 'CODINFOS';
    } else if (this.mainService.getSource() === 'infos') {
      destinyEmail = 'infosfrance.fr';
      brand = 'INFOSFRANCE';
    }
    Email.send({
      Host : 'SSL0.OVH.NET',
      Username : 'sender@infosfrance.fr',
      Password : 'SeA55_jpV',
      To : 'knowmore@' + destinyEmail,
      From : this.email,
      Subject : 'Email received at ' + brand +  ' from ' + this.name,
      Body : this.message
  }).then(
    (res) => {
      if (res === 'OK') {
        this.emailSendedMessage = 'contact.email send success';
      }
    }
  );
  }

}
